import React, {Fragment, ReactElement, useEffect} from 'react';
import {
  setAppBarTitle,
  setBackNavAction,
  setBackNavEnabled,
} from '../../../redux/globalSlice';
import {useHistory} from 'react-router-dom';
import {useAppDispatch, useAppSelector} from '../../../redux/hooks';
import SizeCard from '../../../components/card/Card';
import {useState} from 'react';
import {BackButtonAction} from '../../../core/utils/string.util';
import {
  arrangeMissingSizeData,
  missingSizeOrderedInfo,
  resetState,
  productSizeData,
  MissingSizeData,
} from '../../../redux/missingSizeApiSlice';
import {setColor, setSize} from '../../../core/localstorage-data';
import {producDetailInfo} from '../../../lib/types';
import {eventNames, scanCodeEvent} from '../../../lib/constants';
import {referral_eCommerce, scanBarocodeGtmData, selectSize} from '../../../lib/tagmanager';
import {WebsiteUrl} from '../../../lib/constants';

const SelectMissingSizes = (): ReactElement => {
  const navigate = useHistory();
  const [selectedSize, setSelectedSize] = useState<string | null>(null);
  const [checkAvailability, setCheckAvailbility] = useState(true);
  const [productSizeAvailable, setProductSizeAvailable] = useState(false);
  const dispatch = useAppDispatch();
  const missingSizeDetail = useAppSelector(missingSizeOrderedInfo);
  const productSearchData = useAppSelector(productSizeData);
  const missingSizeApiData = useAppSelector(MissingSizeData);
  useEffect(() => {
    if (missingSizeDetail != undefined) {
      if (missingSizeDetail.productSizeStatusCheck == true) {
        setProductSizeAvailable(true);
      }
    }
    if (missingSizeDetail == undefined) {
      navigate.replace('missingsizes');
    }
  }, [missingSizeDetail]);

  useEffect(() => {
    dispatch(setAppBarTitle('Select size'));
    dispatch(setBackNavEnabled(true));
    dispatch(setBackNavAction(BackButtonAction.TO_BARCODE_PAGE));

    return () => {
      dispatch(setAppBarTitle(''));
      dispatch(setBackNavEnabled(false));
      dispatch(setBackNavAction(undefined));
    };
  }, [setAppBarTitle]);

  const selectSizeHandler = (size: string) => {
    setSelectedSize(size);
    setCheckAvailbility(false);
  };
  console.log(missingSizeDetail);

  const buttonHandler = () => {
    if (selectedSize != null) {
      for (const color in missingSizeDetail?.productByCode) {
        //const element = missingSizeDetail.productByCode[color];
        //console.log(element);
        if (color == missingSizeDetail?.productColor?.color) {
          const element = missingSizeDetail.productByCode[color];
          element.map((variant: any) => {
            if (variant.size == selectedSize) {
              const productGtmDetail: producDetailInfo = {
                scan_Code_Number: productSearchData.itemCode,
                product_Name: missingSizeDetail.productName,
                price: missingSizeDetail.productPrice.toString(),
                product_ID: productSearchData.base_product,
                //order_Address_City:string;
                //      first_Name: customerProfileData.firstName,
                //last_Name:string,
                //category_Name:string;
                //category_Type:string;
                //brand: 'not Present',
                size: selectedSize,
                stock_Status: variant.stock.stockLevel.toString(),
                eventName: eventNames.checkSizeBarcode,
                event: scanCodeEvent,
              };
              scanBarocodeGtmData(productGtmDetail);
            }
          });
        }
      }
      if (missingSizeDetail?.inStockSelectedProduct.includes(selectedSize)) {
        let code = '';

        for (const color in missingSizeDetail.productByCode) {
          //const element = missingSizeDetail.productByCode[color];
          //console.log(element);
          if (color == missingSizeDetail.productColor?.color) {
            const element = missingSizeDetail.productByCode[color];
            element.map((variant: any) => {
              if (variant.size == selectedSize) {
                code = variant.code;
                selectSize(variant.code,variant.size,color,missingSizeApiData.price.value,missingSizeApiData.name,variant.stock.stockLevelStatus)
              }
            });
            console.log(element);
          }

          console.log(color);
        }

        const url = missingSizeDetail?.productUrl?.split('p/');
        referral_eCommerce(`${WebsiteUrl}'p/'${code}/?utm_source=buddy.maxfashion.in&utm_medium=referral&utm_campaign=missing_sizes`)
        window.open(WebsiteUrl + 'p/' + code, '_blank', 'noreferrer');
        return;
      }
      if (missingSizeDetail?.outOfStockSelectedProduct.includes(selectedSize)) {
        //navigation to notify screen with size and color save it in localstorage
        const colorData = missingSizeDetail?.productColor?.color;
        if (colorData != undefined) {
          setColor(colorData);
        }
        setSize(selectedSize);
        selectSize(productSearchData.base_product,selectedSize,colorData,missingSizeApiData.price.value,missingSizeApiData.name,"outOfStock")
        navigate.replace('notify');
        //   notify(selectedSize, missingSizeDetail.productColor?.color);
        return;
      }

      for (const size in missingSizeDetail?.colorsBySize) {
        // const colors = missingSizeDetail?.colorsBySize[size];
        if (size === selectedSize) {
          setSize(selectedSize);
          selectSize(productSearchData.base_product,selectedSize,productSearchData.color,missingSizeApiData.price.value,missingSizeApiData.name,"outOfStock");
          navigate.push('selectcolor');
          // console.log(colors);
          //navigate to color screen with sslected size
          // missingSize(selectedSize);
          return;
        }
      }
    }
  };

  return (
    <Fragment>
      <div className="container mx-auto z-10 p-4 ">
        <div className="pt-6 w-full  bg-color">
          <div className=" grid place-items-center">
            <span className="font-roboto text-2xl">
              Select a <b>size</b>
            </span>
          </div>

          <SizeCard classes="w-full rounded-lg bg-white ">
            <div className="pt-8 ml-4 flex justify-between leading-3">
              <div>
                <span className="font-medium font-roboto">Max fashion</span>
              </div>
              <div className="text-right mr-4">
                <span className=" font-roboto">
                  {'\u20B9'}
                  {missingSizeDetail?.productPrice}
                </span>
              </div>
            </div>
            <div className="pt-4 ml-4 flex justify-between leading-4">
              <div>
                <span className="text-small leading-1 text-left font-medium font-roboto text-black_zero">
                  {missingSizeDetail?.productName}
                </span>
              </div>
              <div className=" text-right mr-4">
                <div>
                  <span className="text-xs font-roboto min-w-min">
                    Colour:<b> {missingSizeDetail?.productCurrentColor}</b>
                  </span>
                </div>
                <div style={{minWidth: '100px'}}>
                  <span className="text-xs font-roboto text-left">
                    Size: <b>{missingSizeDetail?.productSize}</b>
                  </span>
                </div>
              </div>
            </div>
            <div className=" ml-4 flex justify-between leading-3 pb-4 ">
              <div></div>
              <div className=" text-right mr-4"></div>
            </div>
          </SizeCard>
          <div className="mt-12">
            {productSizeAvailable ? (
              <div className="text-xm font-semibold font-roboto grid place-items-center  ">
                <span className="  text-red-700">
                  No size available for this product
                </span>
              </div>
            ) : (
              <div>
                <span className="text-xm font-semibold font-roboto grid place-items-center">
                  Which size are you looking for?
                </span>

                <div className="mt-3   flex-wrap">
                  {missingSizeDetail?.productColor?.sizes.map((size, index) => (
                    <button
                      key={index}
                      onClick={() => selectSizeHandler(size)}
                      className={`w-auto h-50 px-4 py-3 m-2 whitespace-nowrap overflow-ellipsis overflow-hidden flex-auto font-semibold font-roboto bg-blue_four rounded-radius10 ${
                        selectedSize === size
                          ? 'outline-none border border-blue_border'
                          : ''
                      } focus:outline-none`}
                      style={{minWidth: '60px'}}>
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}
          </div>
          <div>
            <button
              className={`w-full h-12 mt-8 cursor-none-allowed text-white rounded-xl border-solid grid place-items-center focus:outline-none font-medium font-roboto primary normal`}
              disabled={checkAvailability}
              onClick={buttonHandler}>
              Check for availability on website
            </button>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
export default SelectMissingSizes;
